export default __webpack_public_path__ + "static/media/distanstolkning4.fa8ee022.png";